(function () {
  "use strict";

  class ProductEngineComponent extends HTMLElement {
    constructor() {
      super();
    }

    static get observedAttributes() {
      return ["product"];
    }

    get product() {
      return this._product;
    }

    set product(value) {
      this._product = value;
      this.render();
    }

    connectedCallback() {
      if (this._product) {
        this.render();
      }
    }

    render() {
      const engines = this?._product?.attributes?.engine?.text;

      if (engines && engines.length) {
        this.innerHTML = `
        <h3 class="rcc-search__product__subtitle">
          Engine: ${engines.join(", ")}
        </h3>
        `;
      }
    }
  }

  customElements.define("rcc-product-engine", ProductEngineComponent);
})();
